module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAVUlEQVQ4je2VQQpAIQgFu9O8W3e5ukC1inbR/yRFOOBOB1HEEE4DVKBuF0vKkrKLXTwAEpC2i3913ItmARSgrORKirZis1GscNfyXPy42PI1xS8X1QBS1Hs9z824YQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/plus_button@2x.png
// module id = JZQm
// module chunks = 28